export default "__VITE_ASSET__qQ_5YbfU__"